import { useState } from 'react'
import { FiUser, FiCalendar, FiDownload } from 'react-icons/fi'
// import { FiLayout } from 'react-icons/fi' // usado pelo botão de layout teste comentado abaixo
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs'
import { ReactComponent as GeneratorIcon } from '../../../../shared/img/icon/generator.svg'
import { downloadServiceOrderPDF, openServiceOrderPDF } from '../../../../utils/generateServiceOrderPDF'
import useFlashMessage from '../../../../hooks/useFlashMessage'

const formatDate = (value) => {
    if (!value) return ''
    const [year, month, day] = value.split('-')
    return day && month && year ? `${day}/${month}/${year}` : value
}

const getShortName = (fullName) => {
    if (!fullName) return ''
    const parts = fullName.trim().split(/\s+/)
    return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1]}` : parts[0]
}

// Paleta categórica (8 matizes, ordem fixa validada para distinção entre cores)
const TECHNICIAN_COLORS = [
    { bg: '#2a78d6', text: '#ffffff' }, // blue
    { bg: '#1baf7a', text: '#ffffff' }, // aqua
    { bg: '#eda100', text: '#1f2937' }, // yellow
    { bg: '#008300', text: '#ffffff' }, // green
    { bg: '#4a3aa7', text: '#ffffff' }, // violet
    { bg: '#e34948', text: '#ffffff' }, // red
    { bg: '#e87ba4', text: '#ffffff' }, // magenta
    { bg: '#eb6834', text: '#ffffff' }, // orange
]

const getTechnicianColor = (key) => {
    const str = String(key || '')
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0
    }
    return TECHNICIAN_COLORS[hash % TECHNICIAN_COLORS.length]
}

function ListServiceOrderConcludedRow({ dataArray }) {
    const [busyId, setBusyId] = useState(null)
    const { setFlashMessage } = useFlashMessage()

    async function handleView(item) {
        // precisa abrir a aba antes dos awaits, senão o navegador bloqueia como pop-up
        const newTab = window.open('', '_blank')
        setBusyId(item._id)
        try {
            await openServiceOrderPDF(item, newTab)
        } catch (error) {
            setFlashMessage('Não foi possível gerar o PDF desta OS.', 'error')
        }
        setBusyId(null)
    }

    async function handleDownload(item) {
        setBusyId(item._id)
        try {
            await downloadServiceOrderPDF(item)
        } catch (error) {
            setFlashMessage('Não foi possível gerar o PDF desta OS.', 'error')
        }
        setBusyId(null)
    }

    return (
        <div>
            {dataArray && dataArray.map((item) => {
                const isBusy = busyId === item._id
                return (
                    <div key={item._id} className="pg-item">
                        <div className="pg-item-main">
                            <div className="pg-item-header">
                                <span className="pg-item-name">{item.code || '—'}</span>
                                <span className="so-status-badge so-status-concluida">Concluída</span>
                            </div>

                            <div className="so-item-desc">{item.name}</div>

                            <div className="so-item-meta">
                                <span className="so-item-meta-item">
                                    <FiUser size={11} />
                                    {item.client?.label || item.client?.name || '—'}
                                </span>
                                {item.generator?.label && (
                                    <>
                                        <span className="so-item-meta-sep">·</span>
                                        <span className="so-item-meta-item">
                                            <GeneratorIcon className="so-item-meta-icon" />
                                            {item.generator.label}
                                        </span>
                                    </>
                                )}
                                {item.scheduledDate && (
                                    <>
                                        <span className="so-item-meta-sep">·</span>
                                        <span className="so-item-meta-item">
                                            <FiCalendar size={11} />
                                            Agendado: {formatDate(item.scheduledDate)} das {item.scheduledStartTime} às {item.scheduledEndTime}
                                        </span>
                                    </>
                                )}
                                {item.technicians?.length > 0 && (
                                    <>
                                        <span className="so-item-meta-sep">·</span>
                                        <span className="so-technician-badges">
                                            {item.technicians.map((t) => {
                                                const color = getTechnicianColor(t._id || t.value || t.name)
                                                return (
                                                    <span
                                                        key={t._id || t.value || t.name}
                                                        className="so-technician-badge"
                                                        style={{ backgroundColor: color.bg, color: color.text }}
                                                    >
                                                        {getShortName(t.name || t.label)}
                                                    </span>
                                                )
                                            })}
                                        </span>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className='shd-row-box-item-action'>
                            {/* Botão de layout teste (pré-visualização) — comentado, não excluído.
                                Reativar se precisarmos ajustar o layout do PDF futuramente. */}
                            {/* <FiLayout
                                className="so-icon-review"
                                title="Pré-visualização (teste)"
                                onClick={() => window.open(`/serviceOrder/pdf-preview/${item._id}`, '_blank')}
                            /> */}
                            <BsFillFileEarmarkPdfFill
                                className={`so-icon-report ${isBusy ? 'so-icon-disabled' : ''}`}
                                title={isBusy ? 'Gerando...' : 'PDF'}
                                onClick={() => !isBusy && handleView(item)}
                            />
                            <FiDownload
                                className={`so-icon-download ${isBusy ? 'so-icon-disabled' : ''}`}
                                title={isBusy ? 'Gerando...' : 'Baixar'}
                                onClick={() => !isBusy && handleDownload(item)}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ListServiceOrderConcludedRow
